import { url } from "../config/config";
import geolocationService from "../services/GeolocationService";

class Auth {
  constructor() {
    this.compLatitude = localStorage.getItem("compLatitude");
    this.compLongitude = localStorage.getItem("compLongitude");
    this.userLatitude = null;
    this.userLongitude = null;
    this.token = JSON.parse(localStorage.getItem("currentUser"));
    this.mobile = localStorage.getItem("mobile");
  }

  isAuthenticated() {
    return this.token != null && new Date().getTime() < this.token.expire;
  }

  getAuthToken() {
    return this.token.token;
  }

  addTime() {
    // console.log("Before: " + this.token.expire);
    this.token.expire += 5 * 60 * 1000; // Adds 5 minutes
    // console.log("After: " + this.token.expire);
  }

  getLoginTokenTime() {
    return this.token.expire;
  }

  getExpiryTokenTime() {
    return this.token.refreshToken;
  }

  getMobileNo() {
    return this.mobile;
  }

  setCompCord(lat, lon) {
    this.compLatitude = lat;
    this.compLongitude = lon;
  }

  setUserCord(lat, lon) {
    this.userLatitude = lat;
    this.userLongitude = lon;
  }

  getUserLongitude(){
    return this.userLongitude;
  }

  getUserLatitude(){
    return this.userLatitude;
  }

  isValidDistance() {
    var validDistance = 100;
    geolocationService
      .getCurrentLocation()
      .then((location) => {
        var dis = geolocationService.calculateDistance(
          this.compLatitude,
          this.compLongitude,
          location.latitude,
          location.longitude
        );
        this.setUserCord(location.latitude, location.longitude);
        console.log(
          "Lat: A: " + this.compLatitude + " B: " + location.latitude
        );
        console.log(
          "Lon: A: " + this.compLongitude + " B: " + location.longitude
        );
        // console.log("compLatitude:" + this.compLatitude);
        // console.log("compLongitude:" + this.compLongitude);
        // console.log("latitude:" + location.latitude);
        // console.log("longitude:" + location.longitude);
        console.log("Dis:" + dis);

        if (dis > validDistance) {
          authenticationService.signOut();
          this.props.history.replace("/");
        }
      })
      .catch((error) => {
        // this.state.errorLocation = error;
      });
  }

  signOut() {
    console.log("Sign Out");
    // Optimized the removal process using a loop
    // const itemsToRemove = [
    //   "currentUser",
    //   "mobile",
    //   "response",
    //   "acc_name",
    //   "timer",
    //   "isUserSettingAvail",
    //   "ITEM",
    //   "compLatitude",
    //   "compLongitude",
    // ];

    // itemsToRemove.forEach((item) => localStorage.removeItem(item));
    localStorage.clear();
    sessionStorage.clear();
    // Clear token and mobile
    this.token = null;
    this.mobile = null;
  }

  async login(username, password, phone, authCode, lat, lon) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: username,
        password: password,
        phone: phone,
        uid: authCode,
        latitude: lat,
        longitude: lon,
      }),
    };
    // console.log("requestOptions: " + JSON.stringify(requestOptions));
    return fetch(`${url}prod/login`, requestOptions)
      .then((response) => {
        return response.text().then((text) => {
          console.log("Res: " + JSON.stringify(text));
          const data = text && JSON.parse(text);
          if (data.token == null || !response.ok) {
            const error =
              (data && data.message) ||
              (response.statusText === "" ? "Invalid User" : "");

            return Promise.reject(error);
          }
          return data;
        });
      })
      .then((user) => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem("currentUser", JSON.stringify(user));
        this.token = user;
        this.mobile = phone;
        localStorage.setItem("mobile", this.mobile);
        return user;
      });
  }
}

const authenticationService = new Auth();

export default authenticationService;
